import { render, staticRenderFns } from "./Github.vue?vue&type=template&id=54694e10&"
import script from "./Github.vue?vue&type=script&lang=js&"
export * from "./Github.vue?vue&type=script&lang=js&"
import style0 from "./Github.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports